import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customer-list-filter',
  templateUrl: './customer-list-filter.component.html',
  styleUrls: ['./customer-list-filter.component.css']
})
export class CustomerListFilterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
